import MoreHorizRoundedIcon from "@mui/icons-material/MoreHorizRounded";
import { ListItemIcon } from "@mui/material";
import type { MouseEvent } from "react";

interface Props {
  onShowOptions: (x: number, y: number) => void;
}

const MeasureGroupOptionsIcon = ({ onShowOptions }: Props) => {
  const handleClick = (evt: MouseEvent<HTMLDivElement>) => onShowOptions(evt.clientX, evt.clientY);

  return (
    <ListItemIcon className="row-actions" sx={{ minWidth: "1.25rem", mr: "6px" }} onClick={handleClick}>
      <MoreHorizRoundedIcon color="secondary" />
    </ListItemIcon>
  );
};

export default MeasureGroupOptionsIcon;
